export const ScrollModes = Object.freeze({
  SCROLL: 0,
  ROLL: 1
});
